var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between h-100"},[_c('div',{staticClass:"d-block w-100 h-100"},[_c('Logo',{attrs:{"data":_vm.data}})],1),_c('div',{staticClass:"d-block w-100 h-100"},[_c('Favicon',{attrs:{"data":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }